// extracted by mini-css-extract-plugin
module.exports = {"authSpinner":"AuthWrapper_authSpinner__hpNe7"};